import type {
  AriaAttributes,
  ButtonHTMLAttributes,
  DetailedHTMLProps,
  ReactNode,
} from 'react';

import { classNames } from '../../../DesignSystem/Utils/classNames';

type RoundedButtonProps = DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
> &
  AriaAttributes & {
    children: ReactNode;
    onClick: () => void;
    isSelected?: boolean;
  };

export function RoundedButton({
  children,
  onClick,
  isSelected = false,
  ...buttonProps
}: RoundedButtonProps) {
  return (
    <button
      onClick={onClick}
      className={classNames('flex h-fit w-fit items-center rounded-2xl px-3', {
        'bg-gray-3 hover:bg-gray-4': !isSelected,
        'bg-primary-2 hover:bg-primary-1': isSelected,
      })}
      {...buttonProps}
    >
      {children}
    </button>
  );
}
